import { Injectable } from '@angular/core';
import { filter, interval } from 'rxjs';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class UpdaterService {

  constructor(
    public updates: SwUpdate,
    private toastCtrl: ToastController,
  ) {
    if (this.updates.isEnabled) {
      // Check immediately
      this.updates.checkForUpdate();
      
      // Check every hour
      interval(1 * 60 * 60 * 1000).subscribe(() => {
        this.updates.checkForUpdate();
      });
      
      this.initUpdateListener();
    }
  }

  private initUpdateListener() {
    this.updates.versionUpdates
      .pipe(
        filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
      )
      .subscribe(() => {
        this.confirmUpdateToast('top');
      });
  }

  async confirmUpdateToast(position: 'top' | 'middle' | 'bottom') {
    const toast = await this.toastCtrl.create({
      position: position,
      header: 'È disponibile un nuovo aggiornamento',
      message: 'Clicca su Applica per aggiornare.',
      color: 'warning',
      cssClass: 'update-toast',
      buttons: [
        {
          text: 'Applica',
          role: 'apply',
          handler: () => {
            this.updateNewVersion();
            return true;
          },
        },
        {
          icon: 'close',
          role: 'cancel',
          handler: () => {
            // Re-show after 5 seconds if cancelled
            setTimeout(() => this.confirmUpdateToast(position), 5000);
            return true;
          }
        }
      ]
    });

    await toast.present();
  }

  private updateNewVersion(): void {
    this.updates.activateUpdate().then(() => {
      document.location.reload();
    });
  }
}
